import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Icon from './Icon';
const createIconComponent = (SvgElement, iconName) => {
  return props => /*#__PURE__*/React.createElement(Icon, _extends({
    icon: iconName
  }, props), /*#__PURE__*/React.createElement(SvgElement, null));
};
export default createIconComponent;